export interface EmailTemplateFilter {
  key?: string;
  type?: string;
  status?: string;
}

export enum EmailTemplateLocalStorage {
  KEY = 'emailTemplateFilterKey',
  TYPE = 'emailTemplateFilterType',
  STATUS = 'emailTemplateFilterStatus',
}
